"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
/**
 * a selected connection can be a single airconnection (RT, OJ, O, R)
 * or two oneway's (O + R)
 */
var SelectedConnection = /** @class */ (function () {
    function SelectedConnection(conns) {
        this.data = [];
        this.data = conns;
    }
    SelectedConnection.prototype.isValid = function () {
        if (this.data.length === 0 || this.data.length > 2) {
            return false;
        }
        else if (this.data.length === 2) {
            return this.data[0].flightDirection === 'O' &&
                !!this.data[0].outgoingFlight &&
                this.data[1].flightDirection === 'R' &&
                !!this.data[1].returnFlight;
        }
        else {
            return true;
        }
    };
    SelectedConnection.prototype.displayOutgoing = function () {
        /*        if (!this.isValid()) {
                    return null
                }
        */
        var conn = this.data[0];
        if (!conn || !conn.outgoingFlight) {
            return null;
        }
        return {
            segments: conn.outgoingFlight.segments,
            airportName: conn.outgoingFlight.segments[0].departureAirportName
        };
    };
    SelectedConnection.prototype.displayReturning = function () {
        /*        if (!this.isValid()) {
                    return null
                }
        */
        var conn = this.data.length === 2 ? this.data[1] : this.data[0];
        if (!conn || !conn.returnFlight) {
            return null;
        }
        return {
            segments: conn.returnFlight.segments,
            airportName: lodash_1.last(conn.returnFlight.segments).arrivalAirportName
        };
    };
    SelectedConnection.prototype.totalPrice = function () {
        if (!this.isValid()) {
            return 0;
        }
        if (this.data.length === 1) {
            var out = this.data[0].outgoingFlight ? this.data[0].outgoingFlight.price : 0;
            var ret = this.data[0].returnFlight ? this.data[0].returnFlight.price : 0;
            return out + ret;
        }
        return this.data[0].outgoingFlight.price + this.data[1].returnFlight.price;
    };
    SelectedConnection.prototype.transportOptionsForBooking = function () {
        var _this = this;
        if (!this.isValid()) {
            return [];
        }
        return lodash_1.map(this.data, function (conn) {
            return {
                category: conn.class,
                code: conn.code,
                direction: conn.flightDirection,
                type: 'AIR',
                price: _this.totalPrice()
            };
        });
    };
    return SelectedConnection;
}());
exports.SelectedConnection = SelectedConnection;
//# sourceMappingURL=selected_connection.js.map